import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';
import SupplierLayout from '@components/layout/supplier/SupplierLayout.tsx';
import SupplierOrderDetail from '@features/supplier/orders/SupplierOrderDetail.tsx';

const paramSchema = z.object({
  orderId: z.coerce.number().positive(),
});

export const Route = createFileRoute('/s/$orgId/$portalId/orders/$orderId')({
  params: {
    parse: v => paramSchema.parse(v),
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  return (
    <SupplierLayout>
      <SupplierOrderDetail orderId={orderId} />
    </SupplierLayout>
  );
}
